import { FC } from 'react'

import { TypeStyleHeadlineSmall } from '@syconium/little-miss-figgy'
import { Dialog } from '@syconium/little-miss-figgy/dist/components'

import { gql } from '../../../../../../../__generated__/graphql/catalog'
import { SizeChartFragment } from '../../../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../../_providers/TranslationProvider.client'
import { NextDialogProvider, NextDialogTrigger } from '../../../../../dialogs/NextDialog.client'

import * as Styles from './SizeChart.styles'
import { SizeChartModalContent } from './SizeChartModalContent'

export type SizeChartTip = NonNullable<SizeChartFragment['tips']>[number]

export type SizeChartTableCells = ReadonlyArray<ReadonlyArray<string>>

export type { SizeChartTable } from './sizeChartData'

gql(`
  fragment SizeChart on SizeChartCG {
      id
      columnNames
      columnValues
      imageUri
      name
      navLabel
      tables {
          id
          cells
          measureImage
          measureTips {
              kind
              tip
              image
          }
          sizeTips {
              kind
              tip
          }
          subtitle
          tabLabel
          title
          visualFiltersSection {
              id
              tiles {
                  id
                  ctaText
                  image
                  iconBadges {
                      id
                      iconText
                  }
              }
          }
      }
      tips {
          kind
          tip
          image
      }
      title
      video
  }
`)

interface Props {
  productHandle: string
  className?: string
}

export const SizeChart: FC<Props> = ({ productHandle, className }) => {
  const {
    sizesSection: { sizeChartCTA, sizeChart: sizeChartText },
  } = useTranslation()
  return (
    <NextDialogProvider>
      <NextDialogTrigger
        render={
          <Styles.SizeChartButton aria-label={sizeChartCTA} className={className}>
            {sizeChartCTA}
          </Styles.SizeChartButton>
        }
      />
      <Styles.DialogDrawer
        analyticsTitle='Size Chart'
        variant='right-drawer'
        header={
          <Dialog.Header
            title={<TypeStyleHeadlineSmall>{sizeChartText.modalHeadline}</TypeStyleHeadlineSmall>}
            dismiss={<Dialog.Dismiss aria-label='Close modal' />}
          />
        }
        content={<Styles.DrawerContent />}
        unmountOnHide={true}
      >
        <SizeChartModalContent productHandle={productHandle} />
      </Styles.DialogDrawer>
    </NextDialogProvider>
  )
}
